// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-box .button[data-v-0a592b46]{float:right;font-size:12px;padding:4px 8px}", "",{"version":3,"sources":["webpack://./resources/js/views/Communications.vue"],"names":[],"mappings":"AACA,sCAAqB,WAAA,CAAa,cAAA,CAAgB,eAGlD","sourcesContent":["\n.content-box .button{float:right; font-size:12px; padding:4px 8px;}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
